// frontend/src/components/GoogleSignInButton.jsx
// ✅ GOOGLE OAUTH VERSION (renamed from PiSignInButton)

import React from "react";
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from "../lib/useAuth";

const pill = {
  display:"inline-flex",
  alignItems:"center",
  justifyContent:"center",
  padding:"14px 22px",
  borderRadius:28,
  border:"1px solid #4285f4",
  background:"#4285f4",
  color:"#fff",
  fontWeight:700,
  fontSize:16,
  letterSpacing:.2,
  cursor: "pointer",
  transition: "opacity 0.2s ease",
};

const pillDisabled = {
  ...pill,
  opacity: 0.6,
  cursor: "not-allowed",
};

export default function GoogleSignInButton({ label = "Sign in with Google" }) {
  const { signIn } = useAuth();
  const [busy, setBusy] = React.useState(false);

  const handleSuccess = async (credentialResponse) => {
    try {
      setBusy(true);
      console.log("[GoogleSignInButton] Authentication successful");
      
      // Call the context signIn with the credential
      await signIn(credentialResponse.credential);
      
    } catch (e) {
      console.error("[GoogleSignInButton] Sign in failed:", e);
      alert(e?.message || "Sign in failed");
    } finally {
      setBusy(false);
    }
  };

  const handleError = () => {
    console.error("[GoogleSignInButton] Sign in failed");
    alert("Sign in failed. Please try again.");
  };

  return (
    <div style={{ display: 'inline-block' }}>
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={handleError}
        size="large"
        text="signin_with"
        shape="pill"
        width="250"
        theme="filled_blue"
      />
    </div>
  );
}

// Alternative: Custom styled button (if you want to match your design)
export function GoogleSignInButtonCustom({ label = "Sign in with Google" }) {
  const { signIn } = useAuth();
  const [busy, setBusy] = React.useState(false);

  const handleSuccess = async (credentialResponse) => {
    try {
      setBusy(true);
      console.log("[GoogleSignInButton] Authentication successful");
      await signIn(credentialResponse.credential);
    } catch (e) {
      console.error("[GoogleSignInButton] Sign in failed:", e);
      alert(e?.message || "Sign in failed");
    } finally {
      setBusy(false);
    }
  };

  const handleError = () => {
    console.error("[GoogleSignInButton] Sign in failed");
    alert("Sign in failed. Please try again.");
  };

  return (
    <GoogleLogin
      onSuccess={handleSuccess}
      onError={handleError}
      render={({ onClick, disabled }) => (
        <button
          style={disabled || busy ? pillDisabled : pill}
          onClick={onClick}
          disabled={disabled || busy}
          aria-label={label}
        >
          {busy ? "Signing in…" : label}
        </button>
      )}
    />
  );
}